/* HEARVELA runtime (Shopify theme build of site/src/assets/js/app.js): launch mode, price arms, verified claims +
   reviews, consent-gated tracking, waitlist form, checkout step -> Shopify cart permalink.
   Differences from the static site, all on purpose:
   - Prices: window.SITE.pricing.display holds the Liquid money-formatted VARIANT price per arm (checkout mode), so
     the page shows exactly what Shopify checkout will charge. Waitlist mode: expected-launch-price settings.
   - Checkout step: same-origin permalink /cart/<variant>:1 (replaces the cart, opens Shopify checkout) with
     attributes[price_arm] + attributes[utm_*]. Variant per arm comes from window.SITE.shopify.variants (Liquid).
   - Fit check page (data-page="check"): no trackers load and no events are sent, ever.
   - Meta: when tracking.metaAppInstalled is true, Shopify's Facebook & Instagram app owns PageView,
     InitiateCheckout and Purchase (pixel + CAPI); this file then sends only ViewContent + CTAClick, so nothing
     double-counts. Purchase is never sent from the theme.
   - No sample reviews in any mode. Only verified reviews from the "Customer reviews" section group exist. */
(function () {
  "use strict";
  var S = window.SITE;
  var qs = new URLSearchParams(location.search);
  var REVIEW = qs.get("review") === "1";

  function store(kind) { try { return window[kind]; } catch (e) { return null; } }
  function get(kind, k) { try { var s = store(kind); return s ? s.getItem(k) : null; } catch (e) { return null; } }
  function set(kind, k, v) { try { var s = store(kind); if (s) s.setItem(k, v); } catch (e) { /* storage blocked */ } }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- launch mode ---------- */
  var mode = S.launch.mode === "checkout" ? "checkout" : "waitlist";
  document.documentElement.setAttribute("data-mode", mode);
  $all("[data-show-mode]").forEach(function (el) { el.hidden = el.getAttribute("data-show-mode") !== mode; });
  var PAGE = document.body.getAttribute("data-page");
  var NO_TRACK = PAGE === "check"; // fit check: answers never leave the browser and nothing is tracked

  /* ---------- price arm ---------- */
  var arms = S.pricing.arms;
  var arm = (qs.get("p") || "").toLowerCase();
  if (!arms[arm]) {
    // allow ?p=99 as well as ?p=b
    Object.keys(arms).forEach(function (k) { if (String(arms[k]) === arm) arm = k; });
  }
  if (!arms[arm]) arm = get("localStorage", "hz_arm");
  if (!arms[arm]) {
    var keys = Object.keys(arms);
    arm = keys[Math.floor(Math.random() * keys.length)] || S.pricing.defaultArm;
  }
  set("localStorage", "hz_arm", arm);
  var price = arms[arm];
  var priceText = (S.pricing.display && S.pricing.display[arm]) || ("$" + price);
  $all("[data-price]").forEach(function (el) { el.textContent = priceText; });
  $all("[data-price-unit]").forEach(function (el) { el.textContent = S.pricing.unit; });

  // CTAs: label per mode. Links keep their funnel destination in both modes (presell -> check -> checkout);
  // the checkout page itself shows the waitlist form or the Shopify button depending on mode.
  $all("[data-cta]").forEach(function (el) {
    var label = el.getAttribute("data-label-" + mode);
    if (label) el.textContent = label;
    el.addEventListener("click", function () { track("cta_click", { cta: el.getAttribute("data-cta") }); });
  });

  // delivery estimate: only supplier-confirmed text is shown; ?review=1 in the theme editor shows the draft text flagged
  var D = S.policy.delivery;
  $all("[data-delivery]").forEach(function (el) {
    if (D.confirmed) el.textContent = D.text;
    else if (REVIEW && D.text) { el.textContent = D.text; el.classList.add("unverified"); }
    else el.textContent = "Delivery time is shown before you pay.";
  });

  // reviews: verified only (sections/hearvela-reviews.liquid never outputs anything else). No samples, ever.
  var reviews = (S.proof.reviews || []).filter(function (r) { return r.verified; });
  $all("[data-reviews]").forEach(function (box) {
    reviews.forEach(function (r) {
      var card = document.createElement("figure");
      card.className = "card review";
      var q = document.createElement("blockquote"); q.textContent = r.text;
      var c = document.createElement("figcaption"); c.textContent = r.name + (r.verifiedBuyer ? " · Verified buyer" : "");
      if (r.stars) { var st = document.createElement("p"); st.className = "stars"; st.setAttribute("aria-label", r.stars + " out of 5 stars"); st.textContent = "★★★★★".slice(0, r.stars); card.appendChild(st); }
      card.appendChild(q); card.appendChild(c); box.appendChild(card);
    });
  });
  $all("[data-reviews-section]").forEach(function (sec) { sec.hidden = reviews.length === 0; });
  $all("[data-reviews-empty]").forEach(function (sec) { sec.hidden = reviews.length > 0 && !reviews.every(function (r) { return r.sample; }); });
  $all("[data-verify]").forEach(function (el) { el.hidden = !(S.preview || REVIEW); });

  /* ---------- verified claims only ---------- */
  var claims = S.product.claims.filter(function (c) { return c.verified || REVIEW; });
  $all("[data-claims]").forEach(function (box) {
    var limit = parseInt(box.getAttribute("data-claims"), 10) || 99;
    claims.slice(0, limit).forEach(function (c) {
      var card = document.createElement("div");
      card.className = "card claim" + (c.verified ? "" : " unverified");
      var h = document.createElement("h3"); h.textContent = c.title;
      var p = document.createElement("p"); p.textContent = c.body;
      card.appendChild(h); card.appendChild(p);
      box.appendChild(card);
    });
  });
  $all("[data-claims-section]").forEach(function (sec) { sec.hidden = claims.length === 0; });
  $all("[data-claim-list]").forEach(function (ul) {
    claims.forEach(function (c) {
      var li = document.createElement("li");
      li.textContent = c.title;
      if (!c.verified) li.className = "claim unverified";
      ul.appendChild(li);
    });
  });

  /* ---------- attribution (first touch, this session) ---------- */
  var ATTR_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid"];
  ATTR_KEYS.forEach(function (k) { var v = qs.get(k); if (v && !get("sessionStorage", "hz_" + k)) set("sessionStorage", "hz_" + k, v.slice(0, 200)); });
  function attribution() {
    var out = {};
    ATTR_KEYS.forEach(function (k) { var v = get("sessionStorage", "hz_" + k); if (v) out[k] = v; });
    return out;
  }

  /* ---------- consent + tracking ---------- */
  var T = S.tracking;
  var loaded = false;
  var gpc = T.honorGPC && navigator.globalPrivacyControl === true;
  function consentState() { return gpc ? "rejected" : get("localStorage", "hz_consent"); }

  function loadScript(src) { var s = document.createElement("script"); s.async = true; s.src = src; document.head.appendChild(s); }
  function loadTrackers() {
    if (loaded || NO_TRACK) return; loaded = true;
    if (T.ga4Id) {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
      // page_location without query string so emails/ids in URLs never reach GA
      window.gtag("config", T.ga4Id, { page_location: location.origin + location.pathname, anonymize_ip: true });
      loadScript("https://www.googletagmanager.com/gtag/js?id=" + encodeURIComponent(T.ga4Id));
    }
    if (T.metaPixelId) {
      /* standard Meta base code, inlined */
      !function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v;
        s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); }(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
      if (T.metaAppInstalled) window.fbq("set", "autoConfig", false, T.metaPixelId);
      window.fbq("init", T.metaPixelId);
      // With Shopify's Facebook & Instagram app installed, the app already sends PageView for this pixel.
      if (!T.metaAppInstalled) window.fbq("track", "PageView");
    }
  }

  // Event params are deliberately limited to page/offer facts. Never pass form answers or anything about a person's hearing.
  function track(name, params) {
    params = Object.assign({ price_arm: arm, price: price, page: location.pathname, mode: mode }, params || {});
    if (NO_TRACK) return;
    if (window.console && REVIEW) console.log("[track]", name, params);
    if (!loaded) return;
    if (window.gtag) window.gtag("event", name, params);
    if (window.fbq) {
      if (name === "lead") window.fbq("track", "Lead", { content_name: "launch_list", value: 0, currency: "USD" }, { eventID: params.event_id });
      else if (name === "cta_click") window.fbq("trackCustom", "CTAClick", { cta: params.cta });
      else if (name === "view_offer") window.fbq("track", "ViewContent", { content_name: "offer", value: price, currency: S.pricing.currency || "USD" });
      // InitiateCheckout: only when the Meta app is NOT installed. The app fires it on checkout start; two sources double-count.
      else if (name === "begin_checkout" && !T.metaAppInstalled) window.fbq("track", "InitiateCheckout", { value: params.value, currency: S.pricing.currency || "USD", num_items: params.qty });
      // Purchase is sent by Shopify's Meta channel app (pixel + CAPI) from the Shopify checkout, never from here.
    }
  }
  window.hzTrack = track;

  var banner = document.querySelector(".consent");
  // Mirror the visitor's choice into Shopify's Customer Privacy API, so Shopify's channel-app pixels
  // (Facebook & Instagram, Google & YouTube) follow the same yes/no. Best effort; ignored if unavailable.
  function syncShopifyConsent(choice) {
    try {
      var yes = choice === "accepted";
      var apply = function () {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (cp && cp.setTrackingConsent) cp.setTrackingConsent({ analytics: yes, marketing: yes, preferences: yes, sale_of_data: yes }, function () {});
      };
      if (window.Shopify && window.Shopify.customerPrivacy) apply();
      else if (window.Shopify && window.Shopify.loadFeatures) window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (err) { if (!err) apply(); });
    } catch (e) { /* consent API unavailable */ }
  }
  function decide(choice) {
    set("localStorage", "hz_consent", choice);
    if (banner) banner.hidden = true;
    syncShopifyConsent(choice);
    if (choice === "accepted") { loadTrackers(); trackPage(); }
  }
  $all("[data-consent]").forEach(function (b) { b.addEventListener("click", function () { decide(b.getAttribute("data-consent") === "accept" ? "accepted" : "rejected"); }); });
  $all("[data-open-consent]").forEach(function (a) { a.addEventListener("click", function (e) { e.preventDefault(); if (banner && !gpc) banner.hidden = false; }); });

  function trackPage() { if (PAGE === "offer" || PAGE === "checkout") track("view_offer"); }
  var state = T.consentMode === "opt-out" && !consentState() ? "accepted" : consentState();
  if (state === "accepted") { loadTrackers(); trackPage(); }
  else if (!state && !NO_TRACK && banner && (T.ga4Id || T.metaPixelId || T.metaAppInstalled || REVIEW)) banner.hidden = false;

  /* ---------- waitlist form ---------- */
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return "e" + Date.now().toString(36) + Math.random().toString(36).slice(2);
  }
  $all("form[data-waitlist]").forEach(function (form) {
    var err = form.querySelector(".error");
    var btn = form.querySelector("button[type=submit]");
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      err.textContent = "";
      var email = form.email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = "Please enter a valid email address."; form.email.focus(); return; }
      if (!form.consent_email.checked) { err.textContent = "Please tick the box so we're allowed to email you."; form.consent_email.focus(); return; }
      var eventId = uuid();
      var payload = Object.assign({
        email: email,
        first_name: form.first_name.value.trim().slice(0, 60),
        consent_email: true,
        consent_email_text: form.consent_email.parentNode.textContent.trim(),
        consent_ads: form.consent_ads.checked,
        price_arm: arm,
        price_shown: price,
        page: location.pathname,
        event_id: eventId,
        submitted_at: new Date().toISOString()
      }, attribution());

      btn.disabled = true; btn.textContent = "Sending...";
      var done = function () {
        track("lead", { event_id: eventId });
        set("sessionStorage", "hz_lead", "1");
        location.href = (S.launch.thanksPage || "/thanks.html") + "?a=" + encodeURIComponent(arm);
      };
      if (!S.tracking.leadEndpoint) {
        // Dev / preview: no endpoint configured, nothing leaves the browser.
        console.warn("[waitlist] leadEndpoint not set; lead NOT saved", payload);
        set("sessionStorage", "hz_dev_last_lead", JSON.stringify(payload));
        done();
        return;
      }
      fetch(S.tracking.leadEndpoint, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) })
        .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); done(); })
        .catch(function () {
          btn.disabled = false; btn.textContent = "Notify me at launch";
          err.textContent = "Sorry, that didn't go through. Please try again in a moment.";
        });
    });
  });

  /* ---------- checkout step -> Shopify checkout ---------- */
  $all("form[data-checkout]").forEach(function (form) {
    var err = form.querySelector(".error");
    var totalEl = form.querySelector("[data-total]");
    var variant = S.shopify.variants[arm];
    // keep the no-JS fallback fields in step with the visitor's arm
    var vIn = form.querySelector("[data-hz-variant]"), aIn = form.querySelector("[data-hz-arm]");
    if (vIn && variant) vIn.value = variant;
    if (aIn) aIn.value = arm;
    function qty() { var r = form.querySelector("input[name=qty]:checked"); return r ? Math.min(parseInt(r.value, 10) || 1, S.shopify.maxQty) : 1; }
    // Optional add-ons (order bumps): never pre-ticked; variant + price come from the products picked in theme settings.
    var addonVariants = S.shopify.addonVariants || {}, addonPrices = S.shopify.addonPrices || {};
    function picked() { return $all("input[name=addon]:checked", form).map(function (i) { return i.value; }).filter(function (k) { return addonVariants[k]; }); }
    function extra() { return picked().reduce(function (t, k) { return t + (Number(addonPrices[k]) || 0); }, 0); }
    function fmtMoney(n) { return "$" + (Math.round(n * 100) % 100 ? n.toFixed(2) : String(Math.round(n))); }
    function refresh() {
      if (totalEl) totalEl.textContent = qty() === 1 && !extra() ? priceText : fmtMoney(price * qty() + extra());
      $all(".bump", form).forEach(function (l) { l.classList.toggle("on", l.querySelector("input").checked); });
      $all(".pick", form).forEach(function (l) { l.classList.toggle("on", l.querySelector("input").checked); });
    }
    $all("input[name=qty], input[name=addon]", form).forEach(function (r) { r.addEventListener("change", refresh); });
    refresh();
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      err.textContent = "";
      if (!form.adult.checked) { err.textContent = "Please confirm the hearing aids are for an adult 18+ and you've read the safety checklist."; form.adult.focus(); return; }
      if (!variant) { err.textContent = "Checkout is temporarily unavailable. Please email " + S.brand.supportEmail + "."; return; }
      if (S.shopify.available && S.shopify.available[arm] === false) { err.textContent = "Sorry, this is out of stock right now. Please email " + S.brand.supportEmail + " and we'll tell you when it's back."; return; }
      var q = qty();
      track("begin_checkout", { qty: q, value: price * q + extra() });
      // Same-origin cart permalink: replaces the cart with this one pair and opens Shopify checkout directly.
      // Only offer facts + campaign tags travel as cart attributes, never personal or hearing data.
      var p = new URLSearchParams();
      p.set("attributes[price_arm]", arm);
      var a = attribution();
      ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach(function (k) { if (a[k]) { p.set(k, a[k]); p.set("attributes[" + k + "]", a[k]); } });
      var lines = [encodeURIComponent(variant) + ":" + q].concat(picked().map(function (k) { return encodeURIComponent(addonVariants[k]) + ":1"; }));
      location.href = "/cart/" + lines.join(",") + "?" + p.toString();
    });
  });

  /* ---------- sticky mobile CTA ---------- */
  var sticky = document.querySelector(".sticky-cta");
  var join = document.getElementById("join") || document.querySelector("[data-sticky-hide]");
  if (sticky) {
    document.body.classList.add("has-sticky");
    var joinVisible = false;
    if (join && "IntersectionObserver" in window) {
      new IntersectionObserver(function (en) { joinVisible = en[0].isIntersecting; update(); }).observe(join);
    }
    var update = function () {
      var show = window.scrollY > 500 && !joinVisible;
      sticky.classList.toggle("show", show);
      sticky.setAttribute("aria-hidden", show ? "false" : "true");
      var a = sticky.querySelector("a"); if (a) a.tabIndex = show ? 0 : -1;
    };
    window.addEventListener("scroll", update, { passive: true });
    update();
  }

  $all("[data-year]").forEach(function (el) { el.textContent = new Date().getFullYear(); });
})();
